import {gql} from 'apollo-boost'

export const SAMPLE_SUBSCRIPTION = gql`
  subscription SampleSubscription {
    sampleSubscription {
      id
      message
      sentAt
    }
  }
`

export const PUBLISH_SAMPLE_MESSAGE = gql`
  mutation PublishSampleMessage($message: String!) {
    publishSampleMessage(message: $message) {
      id
      message
      sentAt
    }
  }
`
